import { ElementBuilder } from "@universityofmaryland/web-builder-library";
const createCompositeCardVideoShort = (props) => {
  const { video } = props;
  const setPlay = () => {
    if (video.paused) {
      video.muted = true;
      video.play();
    }
  };
  const setPause = () => {
    if (!video.paused) {
      video.pause();
    }
  };
  video.setAttribute("controls", "true");
  video.setAttribute(
    "controlsList",
    'nodownload nofullscreen noremoteplayback noplaybackrate"'
  );
  video.setAttribute("preload", "metadata");
  video.setAttribute("playsinline", "");
  video.setAttribute("muted", "");
  video.addEventListener("mouseover", setPlay);
  video.addEventListener("focus", setPlay);
  video.addEventListener("mouseleave", setPause);
  video.addEventListener("blur", setPause);
  const composite = new ElementBuilder().withClassName("card-video-short-container").withStyles({
    element: {
      height: "100%",
      width: "100%",
      aspectRatio: "9/16",
      [`& video`]: {
        height: "100%",
        width: "100%",
        objectFit: "cover",
        ["&:hover"]: {
          cursor: "pointer"
        }
      }
    }
  }).withChild(video).build();
  return composite;
};
export {
  createCompositeCardVideoShort
};
//# sourceMappingURL=short.js.map
